/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_No_DataInputs */

const en_admin_posts_no_data = /** @type {(inputs: Admin_Posts_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No posts yet`)
};

const zh_admin_posts_no_data = /** @type {(inputs: Admin_Posts_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无文章`)
};

/**
* | output |
* | --- |
* | "No posts yet" |
*
* @param {Admin_Posts_No_DataInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_no_data = /** @type {((inputs?: Admin_Posts_No_DataInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_No_DataInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_no_data(inputs)
	return zh_admin_posts_no_data(inputs)
});
export { admin_posts_no_data as "admin.posts.no_data" }